<script setup>
import { useRouter } from "vue-router";
import { computed } from "@vue/runtime-dom";
const props = defineProps({
  screen: String,
  paddings: {
    type: String,
    default: '0px',
  },
});
const router = useRouter();
const isYfSorConfig = computed(() => router.currentRoute.value.path === '/configuration' || router.currentRoute.value.path === '/yfs' );

const separatorStyle = computed(() => {
  if (isYfSorConfig.value){
    return{
      width : 'auto',
      margin : '0px 0px -1.1rem 0px',
    }
  }else{
    return{
      width : 'auto'
    }
  }
})
</script>
<template>
  <div class="custom__separator" :style="separatorStyle" v-if="props.screen !== 'user'">
    <div class="custom__separator-border"></div>
  </div>
</template>

<style lang="scss">
.custom__separator {
  height: 5px;
  padding: v-bind(paddings);
  @media (max-width:576px) {
    margin-top: 7px !important;
  }
  .custom__separator-border {
    border-bottom: 1px solid #d9d9d9;
  }
}
</style>
